import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuario } from '../models/usuario.model';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { LoginRequest } from '../models/request/login-request.model';
import { AlterarSenhaRequest } from '../models/request/alterar-senha.request.model';
import { UsuarioNovaSenha } from '../models/usuario-nova-senha.model';
import { AuthenticationService } from './authentication.service';
import { EmpresaResponse } from '../models/response/empresa-response.model';
import { UsuarioResponse } from '../models/response/usuario-response.model';
import { DashboardLocalizacaoResponse } from '../models/response/dashboard-localizacao.model';
import { DashboardMovimentoResponse } from '../models/response/dashboard-movimento.model';
import { DashboardCardResponse } from '../models/response/dashboard-cards.model';
import { LoginResponse } from '../models/response/login-response.model';
import { MeusPedidosRequest } from '../models/request/meus-pedidos-request.model';
import { MeusPedidosResponse } from '../models/response/meus-pedidos-response.model';
import { LocalizacoesResponse } from '../models/response/localizacoes-response.model';
import { LojaResponse } from '../models/response/loja-response.model';
import { ClienteResponse } from '../models/response/cliente-response.model';
import { MedicoResponse } from '../models/medico.model';
import { ProdutoResponse } from '../models/response/produto-response.model';
import { NovoPedidoRequest } from '../models/request/novo-pedido.request.model';
import { Cliente } from '../models/cliente.model';
import { Loja } from '../models/loja.model';
import { TiposClienteResponse } from '../models/response/tiposclientes-response.model';
import { TiposMarketingResponse } from '../models/response/tipos-marketing-response.model';
import { ProfissoesResponse } from '../models/response/profissoes-response.model';
import { GenerosResponse } from '../models/response/generos-response.model';
import { ClienteCamposConfiguracaoResponse } from '../models/response/cliente-campos-configuracao-response.model';
import { EnderecoResponse } from '../models/response/endereco-response.model';
import { CidadesResponse } from '../models/response/cidades-response.model';

@Injectable({
  providedIn: 'root'
})
export class WeblabService {
  public clientes: Array<Cliente>;
  public lojas: Array<Loja>;

  constructor(private httpClient: HttpClient,
    private authenticationService: AuthenticationService) { }

  formDataFromObj(obj: any, ignoreNullOrUndefined = true, formData: FormData | null | undefined = null, path = "") {
      formData = !formData ? new FormData() : formData;
      if (obj) {
          for (var prop in obj) {
              if (ignoreNullOrUndefined) {
                  if (obj[prop] === null || obj[prop] === undefined) {
                      continue;
                  }
              }
              if (obj[prop] && !(obj[prop] instanceof File)  && (Array.isArray(obj[prop]) || typeof obj[prop] == 'object')) {
                  this.formDataFromObj(obj[prop], ignoreNullOrUndefined, formData, path ? `${path}[${prop}]` : prop);
              }
              else {
                  var key = path ? `${path}[${prop}]` : prop;
                  var value = obj[prop] === undefined || obj[prop] === null ? "" : obj[prop];
                  value = typeof value == "boolean" ? (value ? 1 : 0) : value;
                  formData.append(key, value);
              }
          }
      }
      return formData;
  }

  getEmpresa(tokenAcesso: string): Observable<EmpresaResponse> {
    return this.httpClient.post<EmpresaResponse>(`${environment.api_url}/bases/validar`, { "token_de_acesso": tokenAcesso });
  }

  getUsuario(): Observable<UsuarioResponse> {
    return this.httpClient.get<UsuarioResponse>(`${environment.api_url}/oticomlab-usuario`);
  }

  login(usuario: Usuario, tokenAcesso: string): Observable<LoginResponse> {
    let request: LoginRequest = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": tokenAcesso, //"3Sh62mkc11",
      "usuario": usuario.usuario, //"michelle.yukari@gmail.com",
      "senha":usuario.senha, //"SenhaTestes"
    }

    // withCredentials para o navegador gravar o cookie de refresh do Web.
    return this.httpClient.post<LoginResponse>(`${environment.api_url}/login`, request, { withCredentials: true });
  }

  alterarSenha(usuario: UsuarioNovaSenha): Observable<any> {
    let request: AlterarSenhaRequest = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": this.authenticationService.obterEmpresa?.token_acesso, //"3Sh62mkc11",
      "usuario": usuario.usuario,
      "senha":usuario.senhaNova
    }

    return this.httpClient.post(`${environment.api_url}/alterar-senha`, request, { responseType: 'text' });
  }

  esqueciSenha(usuario: string): Observable<any> {
    let request: any = {
      "chave": environment.chave_weblab, //"923pPk59",
      "token_de_acesso": this.authenticationService.obterEmpresa?.token_acesso, //"3Sh62mkc11",
      "usuario": usuario,
      // "senha": usuario.senhaNova
    }

    return this.httpClient.post(`${environment.api_url}/gerar-senha`, request, { responseType: 'text' });
  }

  dashboardCards(): Observable<DashboardCardResponse> {
    return this.httpClient.get<DashboardCardResponse>(`${environment.api_url}/dashboard-cards`);
  }

  dashboardLocalizacoes(): Observable<DashboardLocalizacaoResponse> {
    return this.httpClient.get<DashboardLocalizacaoResponse>(`${environment.api_url}/dashboard-localizacoes`);
  }

  dashboardMovimentacoes(periodo_inicial: string, periodo_final: string): Observable<DashboardMovimentoResponse> {
    return this.httpClient.get<DashboardMovimentoResponse>(`${environment.api_url}/dashboard-movimento?periodo_inicial=${periodo_inicial}&periodo_final=${periodo_final}`);
  }

  meusPedidos(request: MeusPedidosRequest): Observable<MeusPedidosResponse> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append("pagina", request.pagina);
    queryParams = queryParams.append("limite", request.limite);

    if (request.filtro_data)
      queryParams = queryParams.append("filtro_data", request.filtro_data);

    if (request.valor_filtro_data_inicial)
      queryParams = queryParams.append("valor_filtro_data_inicial", request.valor_filtro_data_inicial);

    if (request.valor_filtro_data_final)
      queryParams = queryParams.append("valor_filtro_data_final", request.valor_filtro_data_final);

    if (request.filtro && request.valor_filtro) {
      queryParams = queryParams.append("filtro", request.filtro);
      queryParams = queryParams.append("valor_filtro", request.valor_filtro);
    }

    if (request.localizacao)
      queryParams = queryParams.append("localizacao", request.localizacao);

    return this.httpClient.get<MeusPedidosResponse>(`${environment.api_url}/meus-pedidos`, { params: queryParams });
  }

  localizacoes(): Observable<LocalizacoesResponse> {
    return this.httpClient.get<LocalizacoesResponse>(`${environment.api_url}/localizacoes`);
  }

  clientesCamposConfiguracao(): Observable<ClienteCamposConfiguracaoResponse> {
    return this.httpClient.get<ClienteCamposConfiguracaoResponse>(`${environment.api_url}/clientes/campos-configuracao`);
  }

  generos(): Observable<GenerosResponse> {
    return this.httpClient.get<GenerosResponse>(`${environment.api_url}/generos`);
  }

  profissoes(): Observable<ProfissoesResponse> {
    return this.httpClient.get<ProfissoesResponse>(`${environment.api_url}/profissoes`);
  }

  tiposCliente(): Observable<TiposClienteResponse> {
    return this.httpClient.get<TiposClienteResponse>(`${environment.api_url}/tipos-cliente`);
  }

  tiposMarketing(): Observable<TiposMarketingResponse> {
    return this.httpClient.get<TiposMarketingResponse>(`${environment.api_url}/tipos-marketing`);
  }

  buscarLojas(): Observable<LojaResponse> {
    return this.httpClient.get<LojaResponse>(`${environment.api_url}/lojas`);
  }

  buscarClientes(q: string = "", pagina = 1, limite = 20): Observable<ClienteResponse> {
    return this.httpClient.get<ClienteResponse>(`${environment.api_url}/clientes`, {
      params: {
        q,
        pagina,
        limite
      }
    });
  }

  buscarMedicos(crm: string = "", nome: string = ""): Observable<MedicoResponse> {
    const params: any = { somente_ativos: true };
    if (crm) params['crm'] = crm;
    if (nome) params['nome'] = nome;
    return this.httpClient.get<MedicoResponse>(`${environment.api_url}/medicos`, { params });
  }

  buscarMedicoCod(cod_medico: any): Observable<MedicoResponse> {
    return this.httpClient.get<MedicoResponse>(`${environment.api_url}/medicos`, {
      params: {
        cod_medico,
        pagina: 1,
        limite: 1
      }
    });
  }

  cadastrarCliente(cliente: any): Observable<any> {
    return this.httpClient.post(`${environment.api_url}/clientes`, cliente);
  }
  
  atualizarCliente(id: number, cliente: any): Observable<any> {
    return this.httpClient.patch(`${environment.api_url}/clientes/${id}`, cliente);
  }

  cadastrarMedico(medico: any): Observable<any> {
    return this.httpClient.post(`${environment.api_url}/medicos`, medico);
  }

  buscarEndereco(cep: string): Observable<EnderecoResponse> {
    return this.httpClient.get<EnderecoResponse>(`${environment.api_url}/endereco/${cep}`);
  }

  cidades(codigo_ibge: string | undefined = undefined, cidade: string | undefined = undefined, pagina = 1, limite = 20): Observable<CidadesResponse> {
    const params: any = {};
    if (codigo_ibge) params.codigo_ibge = codigo_ibge;
    if (cidade) params.cidade = cidade;
    if (pagina) params.pagina = pagina;
    if (limite !== undefined && limite !== null) params.limite = limite;

    return this.httpClient.get<CidadesResponse>(
      `${environment.api_url}/cidades`, {
        params
      });
  }

  produtos(q: string = "", loja_id: number | undefined = undefined, especie: string | undefined = undefined, tipo_comercializacao: string | undefined = undefined, pagina = 1, limite = 20): Observable<ProdutoResponse> {
    const params: any = {};
    if (q) params.q = q;
    if (loja_id) params.loja_id = loja_id;
    if (especie) params.especie = especie;
    if (tipo_comercializacao) params.tipo_comercializacao = tipo_comercializacao;
    if (pagina) params.pagina = pagina;
    if (limite !== undefined && limite !== null) params.limite = limite;

    return this.httpClient.get<ProdutoResponse>(
      `${environment.api_url}/produtos`, {
        params
      });
  }

  produtosId(cod_produto: number, loja_id: number | undefined = undefined): Observable<ProdutoResponse> {
    const params: any = {
      cod_produto,
      pagina: 1,
      limite: 1
    };

    if (loja_id) {
      params.loja_id = loja_id;
    }

    return this.httpClient.get<ProdutoResponse>(
      `${environment.api_url}/produtos`, {
        params
      });
  }
  cadastrarPedido(pedido: NovoPedidoRequest): Observable<any> {
    let { anexos, ...dados } = pedido;
    dados = JSON.stringify(dados) as any;

    const formData = new FormData();
    formData.append("dados", dados as any);
    let i = 0;
    for (const anexo of (anexos || [])) {
      if (!anexo.arquivo) {
        continue;
      }

      formData.append(`anexos[${i}][nome_arquivo]`, anexo.nome_arquivo);
      formData.append(`anexos[${i}][tipo_conteudo]`, anexo.tipo_conteudo);
      formData.append(`anexos[${i}][descricao]`, anexo.descricao || "");
      formData.append(`anexos[${i}][arquivo]`, anexo.arquivo);
      i++;
    }
 
    return this.httpClient.post(`${environment.api_url}/ordem-de-servico`, formData);
  }

  atualizarPedido(mov_os_nro: string, pedido: NovoPedidoRequest): Observable<any> {
    let { anexos, ...dados } = pedido;
    dados = JSON.stringify(dados) as any;

    const formData = new FormData();
    formData.append("dados", dados as any);
    let i = 0;
    for (const anexo of (anexos || [])) {
      if (!anexo.arquivo) {
        continue;
      }

      formData.append(`anexos[${i}][nome_arquivo]`, anexo.nome_arquivo);
      formData.append(`anexos[${i}][tipo_conteudo]`, anexo.tipo_conteudo);
      formData.append(`anexos[${i}][descricao]`, anexo.descricao || "");
      formData.append(`anexos[${i}][arquivo]`, anexo.arquivo);
      i++;
    }
 
    return this.httpClient.put(`${environment.api_url}/ordem-de-servico/${mov_os_nro}`, formData);
  }

  pedidoId(idpedido: any, loja_id?: any): Observable<any> {
    const params: any = {};
    if (loja_id) {
      params.loja_id = loja_id;
    }
    
    return this.httpClient.get<any>(`${environment.api_url}/ordem-de-servico/${idpedido}`, { params });
  }

  listarPedido(): Observable<any> {
    return this.httpClient.get<any>(`${environment.api_url}/ordem-de-servico`);
  }

  buscarClienteCod(cod_cliente: any) {
    return this.httpClient.get<ClienteResponse>(`${environment.api_url}/clientes`, {
      params: {
        cod_cliente,
        pagina: 1,
        limite: 1
      }
    });
  }
  
}
